<template>

  <section id="producto-main">
    <div class="container-fluid" style="padding: 0px;">

      <div v-if="isLoading">
        CARGANDO
      </div>
      <div v-else>


        <!-- Photo + Data -->
        <div class="row no-padding">
          <div class="col-lg-6">

            <!-- Carousel -->
            <div id="productoCarousel" class="carousel slide" data-ride="carousel">

              <!--<ol class="carousel-indicators">
                <li data-target="#productoCarousel" data-slide-to="0" class="active"></li>
                <li data-target="#productoCarousel" data-slide-to="1" class=""></li>
                <li data-target="#productoCarousel" data-slide-to="2" class=""></li>
              </ol>-->

              <div class="carousel-inner">

                <div class="item active" >
                  <img :src="product.imageURL_L" class="" >
                </div>
                <div class="item" v-for="photo in product.photos">
                  <img :src="photo.imageURL_L" class="" >
                </div>


              </div>

              <a class="left carousel-control" href="#productoCarousel" data-slide="prev"><img class="icon-prev" src="/static/img/app/fa-arrow-left.png"></a>
              <a class="right carousel-control" href="#productoCarousel" data-slide="next"><img class="icon-next" src="/static/img/app/fa-arrow-right.png"></a>

            </div>

          </div>
          <div class="col-lg-6">

              <div class="box-producto-detalle">

                  <div class="product-badge-agotado" v-if="product.stock_unico<=0">
                      <span>AGOTADO</span>
                  </div>

                  <!-- Breadcrum -->
                  <!-- <nav aria-label="breadcrumb" role="navigation">
                      <ol class="breadcrumb">
                          <li class="breadcrumb-item">Bazar</li>
                          <li class="breadcrumb-item active" aria-current="page">{{product.titulo}}</li>
                      </ol>
                  </nav> -->

                  <h1 class="product-name" v-html="product.titulo"></h1>

                  <div class="box-product-price">
                      <span class="product-price">{{product.precio_mayorista | currency}} <small>+ IVA</small></span>
                  </div>

                  <div class="box-cantidad">

                      <select class="" v-model="quantity">
                          <option :value="n" v-for="n in actualStock">{{n}} unid.</option>
                      </select>

                      <div class="btn-submit" id="btnAddToCart" @click.prevent="quickAddToCart(product)">
                          AÑADIR AL CARRITO
                      </div>

                  </div>

                  <div class="box-descripcion">

                      <div class="box-data">
                          <div class="title">DESCRIPCIÓN</div>
                          <div class="detail" v-html="product.detalle">
                          </div>
                      </div>

                      <div class="separador"></div>

                      <div class="box-data" v-if="product.material || product.dimensiones || product.color || product.origen">
                          <div class="title">INFORMACIÓN DETALLADA</div>

                          <div class="box-info" v-if="product.material">
                              <div class="lbl">Material.</div>
                              <div class="value">{{ product.material }}</div>
                          </div>

                          <div class="box-info" v-if="product.color">
                              <div class="lbl">Color.</div>
                              <div class="value">{{ product.color }}</div>
                          </div>

                          <div class="box-info" v-if="product.dimensiones">
                              <div class="lbl">Dimensiones.</div>
                              <div class="value">{{ product.dimensiones }}</div>
                          </div>

                          <div class="box-info" v-if="product.origen">
                              <div class="lbl">Origen.</div>
                              <div class="value">{{ product.origen }}</div>
                          </div>

                      </div>

                  </div>

              </div>

          </div>
        </div>
      </div>
    </div>
  </section>


</template>

<script>
    import Api from '@/Api';
    export default {
        data(){
          return {
            productId:0,
            isLoading:false,
            quantity:1,
            product:{}
          };
        },
        computed:{
          actualStock(){
            return parseInt(this.product.stock_unico)
          }
        },
        methods:{
          quickAddToCart(product) {

            this.$store.dispatch("addToCart", {product: product, quantity: this.quantity}).then(product => {

                $("nav.micarrito, .overlay-micarrito").addClass("open");
                $("body").addClass("lock");

              //alert("added");
              /* this.$toasted.show("Item " + product.product.titulo + " agregado ", {
                theme: "bubble",
                position: "top-right",
                duration: 5000,
                action: {
                  text: 'Deshacer',
                  onClick: (e, toastObject) => {
                    this.$store.dispatch("removeFromCart", {item: product}).then(product => {
                      toastObject.goAway(0);
                    });

                  }
                }
              });*/

            }).catch(err=>{
              this.$swal({
                title: 'Oops!',
                text: err,
                type: 'error',
              }).then((result) => {

              })
            });
          },
        },
        mounted(){
          this.productId = this.$route.params.id;
          $(window).scrollTop(0);
        },
        async created () {
          let userData = this.$route.params.product;
          if (userData){
            this.product = userData;
          }else{
            Api().get('?func=getProductoData&id='+this.$route.params.id, {
            }).then(data=>{
              if (data.data.success) {
                this.product = data.data.payload.product;
              } else {
                this.$router.push({name: 'Home'});
              }
            }).catch(err=>{
              this.$router.push({name: 'Home'});
            });
          }

        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/ProductDetailPage.vue